export default __webpack_public_path__ + "static/media/pending-status.e449b99e.svg";